import {
	CASCADING_SELECT_CF_TYPE,
	MULTI_CHECKBOXES_CF_TYPE,
	MULTI_SELECT_CF_TYPE,
	RADIO_BUTTONS_CF_TYPE,
	SELECT_CF_TYPE,
} from '@atlassian/jira-platform-field-config/src/index.tsx';
import {
	CASCADINGSELECT_FIELD_TYPE,
	CHECKBOX_FIELD_TYPE,
	MULTISELECT_FIELD_TYPE,
	RADIO_FIELD_TYPE,
	SELECT_FIELD_TYPE,
} from '@atlassian/jira-project-settings-apps-common/src/consts.tsx';

export const doesFieldTypeSupportOptions = (fieldType: string): boolean =>
	[
		SELECT_CF_TYPE,
		MULTI_CHECKBOXES_CF_TYPE,
		CASCADING_SELECT_CF_TYPE,
		CASCADINGSELECT_FIELD_TYPE, // TODO: MCD-2089 revise these field types. These are not proper field types.
		RADIO_FIELD_TYPE,
		SELECT_FIELD_TYPE,
		CHECKBOX_FIELD_TYPE,
		MULTISELECT_FIELD_TYPE,
		MULTI_SELECT_CF_TYPE,
		RADIO_BUTTONS_CF_TYPE,
		// @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type '"select" | "com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons" | "com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes" | "com.atlassian.jira.plugin.system.customfieldtypes:multiselect" | ... 5 more ... | "multiselect"'.
	].includes(fieldType);
